import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '890245410416880';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      try {
        w.fbq('track', 'PageView');
      } catch (e) {}
      return;
    }
    // Initialize fbq queue
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    // Inject the pixel script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
    try {
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (e) {
      // no-op
    }
  }, []);
  return <noscript data-id="element-196">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-197" />
    </noscript>;
}